type Mark = { label: string; t: number };

const marks: Mark[] = [];
const t0 = typeof performance !== 'undefined' ? performance.now() : Date.now();

function now(): number {
  return typeof performance !== 'undefined' ? performance.now() : Date.now();
}

export function markStartup(label: string): void {
  const t = now() - t0;
  marks.push({ label, t });
  if (typeof console !== 'undefined') {
    console.log(`⏱️  [startup] ${label} @ ${t.toFixed(0)}ms`);
  }
}

export function getStartupMarks(): Mark[] {
  return marks.slice();
}

/**
 * Returns a flat properties object suitable for a PostHog event.
 * Key timings are promoted to named properties (startup_total_ms, startup_auth_ms,
 * startup_fonts_ms) so they can be used in percentile queries (p25/p50/p90).
 * Every mark is also included under mark_<slug>_ms for detailed breakdown.
 */
export function getStartupEventProps(): Record<string, number | string> {
  const props: Record<string, number | string> = {};

  const find = (substr: string) => marks.find(m => m.label.includes(substr));

  const renderGate = find('render gate cleared');
  const auth = find('auth init: complete');
  const fonts = find('fonts loaded');

  if (renderGate) props.startup_total_ms = Math.round(renderGate.t);
  if (auth) props.startup_auth_ms = Math.round(auth.t);
  if (fonts) props.startup_fonts_ms = Math.round(fonts.t);

  // Include all marks so the PostHog waterfall is queryable
  for (const m of marks) {
    const key = 'mark_' + m.label.replace(/[^a-z0-9]+/gi, '_').toLowerCase() + '_ms';
    props[key] = Math.round(m.t);
  }

  return props;
}

export function dumpStartupSummary(): void {
  if (typeof console === 'undefined') return;
  console.log('⏱️  [startup] summary:');
  for (let i = 0; i < marks.length; i++) {
    const m = marks[i];
    const prev = i > 0 ? marks[i - 1].t : 0;
    console.log(`  ${m.label.padEnd(40)} ${m.t.toFixed(0)}ms (Δ ${(m.t - prev).toFixed(0)}ms)`);
  }
}

if (typeof globalThis !== 'undefined') {
  (globalThis as { __startupMarks?: () => Mark[] }).__startupMarks = getStartupMarks;
}
